export default __webpack_public_path__ + "media/bundles/Sso/src/components/templates/RegisterTemplate/face_rec-d2c9d7c8c654e820a292039d9ce4ba9f.png";